<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>

    <v-dialog v-model="dialog.detail" persistent width="750">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Detail</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.detail = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <table
            width="100%"
            style="
              font-family: Arial, Helvetica, sans-serif;
              line-height: 1.7;
              font-size: 14px;
            "
          >
            <tr v-for="item in detailRows" :key="item.label">
              <td width="35%">{{ item.label }}</td>
              <td width="3%">:</td>
              <td>{{ item.value || "-" }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            @click="dialog.detail = false"
          >
            Kembali
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoadingComponent v-if="process.loading"></LoadingComponent>

    <v-row
      class="mt-3"
      :class="$vuetify.breakpoint.name !== 'xs' ? 'px-3' : 'pr-0 pl-3'"
      v-if="!process.loading"
    >
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <div class="color-first title font-weight-bold title mt-3">
                  Rekap
                </div>

                <v-tabs v-model="tab" color="#0299B7" class="mt-4">
                  <v-tab v-for="item in tabs" :key="item.value">
                    {{ item.label }}
                  </v-tab>
                </v-tabs>

                <div class="mt-5">
                  <v-row>
                      <v-col cols="12" md="3">
                        <v-select
                          dense
                          :disabled="process.run"
                          outlined
                          :items="list.lab"
                          item-text="nama_laboratorium"
                          item-value="id"
                          v-model="filter.lab"
                          v-on:change="onSelectLab()"
                          label="Laboratorium"
                          color="#0299B7"
                          hide-details
                        >
                          <template v-slot:append>
                            <v-icon color="#7B7B7B"
                              >mdi-chevron-down-box</v-icon
                            >
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select
                          dense
                          :disabled="process.run"
                          outlined
                          :items="activeItemList"
                          item-text="nama"
                          item-value="id"
                          v-model="filter.item"
                          v-on:change="getList()"
                          :label="activeItemLabel"
                          color="#0299B7"
                          hide-details
                        >
                          <template v-slot:append>
                            <v-icon color="#7B7B7B"
                              >mdi-chevron-down-box</v-icon
                            >
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-menu
                          v-model="filter.menu_start"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              outlined
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              label="Periode awal penggunaan"
                              color="#0299B7"
                              :value="formatDate(filter.start_date)"
                              hide-details
                            >
                              <template v-slot:append>
                                <v-icon color="#7B7B7B">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            color="#0299B7"
                            v-model="filter.start_date"
                            @input="
                              filter.menu_start = false;
                              getList();
                            "
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-menu
                          v-model="filter.menu_end"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              outlined
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              label="Periode akhir penggunaan"
                              color="#0299B7"
                              :value="formatDate(filter.end_date)"
                              hide-details
                            >
                              <template v-slot:append>
                                <v-icon color="#7B7B7B">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            color="#0299B7"
                            v-model="filter.end_date"
                            :min="filter.start_date"
                            @input="
                              filter.menu_end = false;
                              getList();
                            "
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row class="mt-7 justify-space-between">
                      <v-col cols="12" md="3">
                        <v-btn
                          @click="exportData()"
                          color="#0299B7"
                          elevation="0"
                          :disabled="process.run || activeRows.length < 1"
                          class="text-capitalize white--text"
                        >
                          <v-icon size="20" class="mr-3">mdi-download</v-icon>
                          Ekspor
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :disabled="process.run"
                          outlined
                          dense
                          :hide-details="true"
                          placeholder="Cari . . ."
                          clearable
                          color="#0299B7"
                          class="mx-3"
                          v-model="filter.search"
                          @click:clear="
                            filter.search = '';
                            getList();
                          "
                          v-on:keyup.enter="getList()"
                          prepend-inner-icon="mdi-magnify"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-card-text
                      class="pa-5 px-0"
                      style="height: calc(100vh - 255px)"
                    >
                      <v-skeleton-loader
                        :loading="process.run"
                        transition="scale-transition"
                        :tile="false"
                        :style="
                          process.run ? 'height: calc(100vh - 305px)' : ''
                        "
                        type="table-tbody"
                      >
                        <v-data-table
                          :headers="activeHeaders"
                          :items="activeRows"
                          :items-per-page="10"
                          class="elevation-1 required"
                        >
                          <template v-slot:[`item.status`]="{ item }">
                            <td>
                              <span :class="getStatusClass(item.status)">{{
                                item.status
                              }}</span>
                            </td>
                          </template>
                          <template v-slot:[`item.aksi`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  x-small
                                  fab
                                  icon
                                  min-width="25"
                                  color="#0299B7"
                                  :disabled="process.run"
                                  @click="detailForm(item)"
                                  class="text-capitalize color-first pa-0 mx-1"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              <span>Detail</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </v-skeleton-loader>
                    </v-card-text>
                </div>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/id";
import { get } from "@/service/Axios";
import { TokenService } from "@/service/Storage.Service";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
import LoadingComponent from "@/components/Loading.vue";

const endpoints = {
  penelitian: "research-recap",
  bahan: "research-recap/item",
  instrumen: "research-recap/instrument"
};

export default {
  mixins: [statusMixin],
  data() {
    return {
      tab: 0,
      tabs: [
        { label: "Penelitian", value: "penelitian" },
        { label: "Bahan", value: "bahan" },
        { label: "Instrumen", value: "instrumen" }
      ],
      dialog: {
        detail: false
      },
      detail: {},
      filter: {
        lab: "all",
        item: "all",
        start_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        menu_start: false,
        menu_end: false,
        search: ""
      },
      process: {
        run: false,
        loading: false
      },
      list: {
        lab: [],
        bahan: [{ id: "all", nama: "Semua" }],
        instrumen: [{ id: "all", nama: "Semua" }]
      },
      rows: {
        penelitian: [],
        bahan: [],
        instrumen: []
      },
      headers: {
        penelitian: [
          { text: "No.", value: "no", sortable: false },
          {
            text: "Jenis penggunaan",
            value: "jenis_penggunaan",
            sortable: false
          },
          {
            text: "Jenis penelitian",
            value: "jenis_penelitian",
            sortable: false
          },
          { text: "Judul", value: "judul", sortable: false },
          { text: "Nama", value: "nama", sortable: false },
          { text: "Instansi", value: "instansi", sortable: false },
          {
            text: "Tujuan penelitian",
            value: "tujuan_penelitian",
            sortable: false
          },
          {
            text: "Nama laboratorium",
            value: "nama_laboratorium",
            sortable: false
          },
          {
            text: "Penggunaan awal",
            value: "penggunaan_awal",
            sortable: false
          },
          {
            text: "Penggunaan akhir",
            value: "penggunaan_akhir",
            sortable: false
          },
          { text: "Status", value: "status", sortable: false, width: "11%" },
          { text: "Aksi", value: "aksi", align: "center", width: "10%" }
        ],
        bahan: [
          { text: "No.", value: "no", sortable: false },
          { text: "Kode", value: "kode", sortable: false },
          { text: "Nama", value: "nama", sortable: false },
          {
            text: "Tanggal penggunaan",
            value: "tanggal_penggunaan",
            sortable: false
          },
          { text: "Kegiatan", value: "kegiatan", sortable: false },
          {
            text: "Jumlah penggunaan",
            value: "jumlah_penggunaan",
            sortable: false
          },
          { text: "Stok", value: "stok", sortable: false },
          { text: "Satuan", value: "satuan", sortable: false },
          {
            text: "Tanggal expired",
            value: "tanggal_expired",
            sortable: false
          },
          {
            text: "Harga satuan internal (Rp)",
            value: "harga_internal",
            align: "right",
            sortable: false
          },
          {
            text: "Harga satuan eksternal (Rp)",
            value: "harga_external",
            align: "right",
            sortable: false
          }
        ],
        instrumen: [
          { text: "No.", value: "no", sortable: false },
          { text: "Kode", value: "kode", sortable: false },
          { text: "Nama", value: "nama", sortable: false },
          {
            text: "Tanggal penggunaan",
            value: "tanggal_penggunaan",
            sortable: false
          },
          { text: "Kegiatan", value: "kegiatan", sortable: false },
          {
            text: "Jumlah penggunaan",
            value: "jumlah_penggunaan",
            sortable: false
          },
          { text: "Satuan", value: "satuan", sortable: false },
          {
            text: "Harga satuan internal (Rp)",
            value: "harga_internal",
            align: "right",
            sortable: false
          },
          {
            text: "Harga satuan eksternal (Rp)",
            value: "harga_external",
            align: "right",
            sortable: false
          }
        ]
      },
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },
  components: {
    Snackbar,
    LoadingComponent
  },
  computed: {
    activeTab() {
      return this.tabs[this.tab].value;
    },
    activeHeaders() {
      return this.headers[this.activeTab];
    },
    activeRows() {
      return this.rows[this.activeTab];
    },
    activeItemLabel() {
      return this.activeTab === "instrumen" ? "Instrumen" : "Bahan";
    },
    activeItemList() {
      return this.activeTab === "instrumen"
        ? this.list.instrumen
        : this.list.bahan;
    },
    detailRows() {
      return [
        { label: "Jenis penggunaan", value: this.detail.jenis_penggunaan },
        { label: "Jenis penelitian", value: this.detail.jenis_penelitian },
        { label: "Judul", value: this.detail.judul },
        { label: "Nama", value: this.detail.nama },
        { label: "Instansi", value: this.detail.instansi },
        { label: "Tujuan penelitian", value: this.detail.tujuan_penelitian },
        { label: "Nama laboratorium", value: this.detail.nama_laboratorium },
        { label: "Penggunaan awal", value: this.detail.penggunaan_awal },
        { label: "Penggunaan akhir", value: this.detail.penggunaan_akhir },
        { label: "Status", value: this.detail.status }
      ];
    }
  },
  watch: {
    tab() {
      this.filter.item = "all";
      this.filter.search = "";
      this.filter.menu_start = false;
      this.filter.menu_end = false;
      this.getList();
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.process.loading = true;
      await this.getLaboratory();
      await this.getItems();
      await this.getInstruments();
      await this.getList();
      this.process.loading = false;
    },

    async getLaboratory() {
      try {
        const params = { flag_lainnya: "1" };
        const { data, status } = await get("laboratory-master", { params });
        if (status === 200 && data.data) {
          const lab = data.data.map((item) => ({
            id: item.id,
            nama_laboratorium: item.namaLaboratorium
          }));
          lab.unshift({ id: "all", nama_laboratorium: "Semua" });
          this.list.lab = lab;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getItems() {
      try {
        const params = {
          id_laboratorium: this.filter.lab,
          search: ""
        };
        const { data, status } = await get("item-master", { params });
        if (status === 200 && data.data) {
          const bahan = data.data.map((item) => ({
            id: item.kdBahan,
            nama: item.namaBahan
          }));
          bahan.unshift({ id: "all", nama: "Semua" });
          this.list.bahan = bahan;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getInstruments() {
      try {
        const params = {
          id_laboratorium: this.filter.lab,
          search: ""
        };
        const { data, status } = await get("instrument-master", { params });
        if (status === 200 && data.data) {
          const instrumen = data.data.map((item) => ({
            id: item.kdInstrumen,
            nama: item.namaInstrumen
          }));
          instrumen.unshift({ id: "all", nama: "Semua" });
          this.list.instrumen = instrumen;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getList() {
      try {
        this.process.run = true;
        let params;
        if (this.activeTab === "penelitian") {
          params = {
            id_laboratorium: this.filter.lab,
            tgl_penggunaan_awal: this.filter.start_date,
            tgl_penggunaan_akhir: this.filter.end_date
          };
        } else {
          params = {
            id_laboratorium: this.filter.lab,
            tgl_penggunaan_awal: this.filter.start_date,
            tgl_penggunaan_akhir: this.filter.end_date,
            search: this.filter.search
          };
          if (this.activeTab === "instrumen") {
            params.kd_instrumen = this.filter.item;
          } else {
            params.kd_bahan = this.filter.item;
          }
        }
        const { data, status } = await get(endpoints[this.activeTab], {
          params
        });
        if (status === 200 && data.data) {
          this.rows[this.activeTab] = data.data.map((item, index) =>
            this.mapRow(item, index)
          );
        }
      } catch (error) {
        console.log(error);
        this.rows[this.activeTab] = [];
      } finally {
        this.process.run = false;
      }
    },

    mapRow(item, index) {
      if (this.activeTab === "penelitian") {
        return {
          no: index + 1,
          jenis_penggunaan: item.jenisPenggunaan || "-",
          jenis_penelitian: item.jenisPenelitian || "-",
          judul: item.judul || "-",
          nama: item.nama || "-",
          instansi: item.instansi || "-",
          tujuan_penelitian: item.tujuanPenelitian || "-",
          nama_laboratorium: item.namaLaboratorium || "-",
          penggunaan_awal: this.formatDate(item.penggunaanAwal),
          penggunaan_akhir: this.formatDate(item.penggunaanAkhir),
          status: item.statusPengajuan || "-",
          uuid: item.uuid || "",
          raw: item
        };
      }

      if (this.activeTab === "bahan") {
        return {
          no: index + 1,
          kode: item.kode || "-",
          nama: item.namaBahan || "-",
          tanggal_penggunaan: this.formatDate(item.tglPenggunaan),
          kegiatan: item.kegiatan || "-",
          jumlah_penggunaan: this.formatNumber(item.jlhPenggunaan),
          stok: this.formatNumber(item.stok),
          satuan: item.satuan || "-",
          tanggal_expired: this.formatDate(item.tglExpired),
          harga_internal: this.formatNumber(item.tarifInternal),
          harga_external: this.formatNumber(item.tarifEksternal),
          raw: item
        };
      }

      return {
        no: index + 1,
        kode: item.kode || "-",
        nama: item.namaInstrumen || "-",
        tanggal_penggunaan: this.formatDate(item.tglPenggunaan),
        kegiatan: item.kegiatan || "-",
        jumlah_penggunaan: this.formatNumber(item.jlhPenggunaan),
        satuan: item.satuan || "-",
        harga_internal: this.formatNumber(item.tarifInternal),
        harga_external: this.formatNumber(item.tarifEksternal),
        raw: item
      };
    },

    onSelectLab() {
      this.filter.item = "all";
      this.getItems();
      this.getInstruments();
      this.getList();
    },

    detailForm(item) {
      if (item.uuid) {
        TokenService.setUuid(item.uuid);
        this.$router.push("/rekap/detail");
      } else {
        this.detail = item;
        this.dialog.detail = true;
      }
    },

    exportData() {
      const headers = this.activeHeaders.filter(
        (item) => item.value !== "aksi"
      );
      const rows = this.activeRows.map((row) =>
        headers.map((header) => this.escapeCsv(row[header.value])).join(",")
      );
      const csv = [
        headers.map((item) => this.escapeCsv(item.text)).join(","),
        ...rows
      ].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `rekap-${this.activeTab}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    escapeCsv(value) {
      const text = value === undefined || value === null ? "" : String(value);
      return `"${text.replace(/"/g, '""')}"`;
    },

    formatDate(value) {
      return value ? moment(value).locale("id").format("DD MMMM YYYY") : "-";
    },

    formatNumber(value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      const number = Number(value);
      return Number.isNaN(number) ? value : number.toLocaleString("id-ID");
    }
  }
};
</script>
